(function ($) {

    /**
     * NumberInput constructor
     *
     * @param options
     * @constructor
     */
    function NumberInput(options) {
        console.log('NumberInput initialization');

        if (!options) {
            throw new Error('No options passed to NumberInput constructor');
        }

        this.options = $.extend({}, ShortList.defaults, options);
        this.setup();
    }

    NumberInput.prototype.setup = function () {
        let self = this;
        let body = $('body');

        body.on('click', '.button-plus', function (event) {
            event.preventDefault();
            self.incrementValue(this);
        });

        body.on('click', '.button-minus', function (event) {
            event.preventDefault();
            self.decrementValue(this);
        });
    };

    NumberInput.prototype.incrementValue = function (obj) {
        let input = $(obj).closest('.plus-minus-group').find('.input-number');
        let currentVal = parseFloat(input.val());

        if (!isNaN(currentVal)) {
            input.val((currentVal + 0.1).toFixed(1));
        } else {
            input.val(0.0);
        }
    }

    NumberInput.prototype.decrementValue = function (obj) {
        let input = $(obj).closest('.plus-minus-group').find('.input-number');
        let currentVal = parseFloat(input.val());

        let isRevenue = false;
        if (input.is('#min_revenue') || input.is('#max_revenue') || input.hasClass('revenue') || input.is('#annual_revenue_min') || input.is('#annual_revenue_max') || input.is('#revenue_min') || input.is('#revenue_max')) {
            isRevenue = true;
        }

        if (!isNaN(currentVal)) {
            if (currentVal <= 0 && isRevenue) {
                input.val(0.0);
            } else {
                input.val((currentVal - 0.1).toFixed(1));
            }
        } else {
            input.val(0.0);
        }
    }

    NumberInput.defaults = {};
    window.NumberInput = NumberInput;

})(jQuery)